import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import { type Position } from './getPositionsService'

const createIdAndDisplayOrderMap = (positions: Position[]): Record<number, number> => {
  const idAndDisplayOrderMap: Record<number, number> = {}

  positions.forEach((position, index) => {
    idAndDisplayOrderMap[position.id] = index + 1
  })
  return idAndDisplayOrderMap
}

export async function patchPositionsDisplayOrder (orgId: number, positions: Position[], positionIdSelected: number): Promise<HttpResponse<Position[]>> {
  const displayIdsAndDisplayOrders = createIdAndDisplayOrderMap(positions)
  return await handleHttpRequest(http.patch(`/api/v1/organizations/${orgId}/positions/`, {
    idAndDisplayOrderMap: displayIdsAndDisplayOrders,
    positionIdSelected
  }))
}
